export default "__VITE_ASSET__Cp$AB2aM__"